// UpworkNavigation.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const AccountSideNav = () => {
  return (
    <div className="bg-white border-r w-64 p-6 flex flex-col h-full">
      {/* Sidebar Header */}
      <div className="mb-8">
        <img
          src="https://placekitten.com/80/80"  // Replace with your actual profile picture URL
          alt="Profile"
          className="w-16 h-16 rounded-full mb-4"
        />
        <p className="text-gray-800 font-semibold text-lg">Your Name</p>
        <p className="text-gray-600 text-sm">Your Role</p>
      </div>

      {/* Sidebar Navigation */}
      <nav className="w-full">
        {/* Navigation Links */}
        {[
               {
                name: "Manage Plans",
                link: "/account-plans",
              },
              {
                name: "Account info",
                link: "/account",
              },
              {
                name: "Save lists",
                link: "/account-savelists",
              },
              {
                name: " My order",
                link: "/account-my-order",
              },
              {
                name: "Change password",
                link: "/account-change-password",
              },
              // {
              //   name: "Change Billing",
              //   link: "/account-billing",
              // },
            ].map((item, index) => (
              <NavLink
                key={index}
                to={item.link}
                className="block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0 text-sm sm:text-base text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"

              >
                {item.name}
              </NavLink>
            ))}
      </nav>
    </div>
  );
};

export default AccountSideNav;
